import { render } from "./ContentDetailLayanan.vue?vue&type=template&id=2f5a2c60&scoped=true"
import script from "./ContentDetailLayanan.vue?vue&type=script&lang=js"
export * from "./ContentDetailLayanan.vue?vue&type=script&lang=js"

import "./ContentDetailLayanan.vue?vue&type=style&index=0&id=2f5a2c60&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5a2c60"]])

export default __exports__